<template>
  <div class="monthly-batch-container">
    <h4 class="monthly-batch-container__title">LithoLam-FBDC Cost (no liner)</h4>
    <div class="table-container-manufacturing">
      <table>
        <tr>
          <th style="background:transparent; border:none;"></th>
          <th style="background:#474C56;border-start-start-radius: 8px;">BOX QTY</th>
          <th style="background:#5F646E;">LITHO<br>SHEETS</th>
          <th style="background:#474C56;" class="gray-text">$/MSF<br>€/SQM</th>
          <th style="background:#5F646E;" class="gray-text">MSF<br>SQM</th>
          <th style="background:#474C56;border-start-end-radius: 8px;">Monthly<br>Costs</th>
        </tr>
        <tr>
          <td class="name-row-cell first">SKU 1<br><span>Structure A</span></td>
          <td>30,000</td>
          <td>5,000</td>
          <td class="gray-text">$38.22<br>€0.385</td>
          <td class="gray-text">106.3<br>9,873</td>
          <td>$4,062<br>€3,799</td>
        </tr>
        <tr>
          <td class="name-row-cell">SKU 2<br><span>Structure A</span></td>
          <td>30,000</td>
          <td>5,000</td>
          <td class="gray-text">$38.2<br>€0.385</td>
          <td class="gray-text">106.3<br>9,873</td>
          <td>$4,062<br>€3,799</td>
        </tr>
        <tr>
          <td class="name-row-cell">SKU 3<br><span>Structure A</span></td>
          <td>25,000</td>
          <td>4,167</td>
          <td class="gray-text">$41.19<br>€0.415</td>
          <td class="gray-text">88.6<br>8,228</td>
          <td>$3,648<br>€3,412</td>
        </tr>
        <tr>
          <td class="name-row-cell">SKU 4<br><span>Structure A</span></td>
          <td>10,000</td>
          <td>1,667</td>
          <td class="gray-text">$68.00<br>€0.685</td>
          <td class="gray-text">35.4<br>3,292</td>
          <td>$2,409<br>€2,254</td>
        </tr>
        <tr>
          <td class="name-row-cell last">SKU 5<br><span>Structure A</span></td>
          <td>5,000</td>
          <td>833</td>
          <td class="gray-text">$112.73<br>€1.135</td>
          <td class="gray-text">17.7<br>1,645</td>
          <td>$1,996<br>€1,887</td>
        </tr>
        <tr class="total-row">
          <td class="title-row" style="border-end-start-radius: 8px;">SUM TOTAL:</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td style="border-end-end-radius: 8px; text-align: start;"><span
              style="font-size: 28px;">$16,176</span><br>€15,132</td>
        </tr>
      </table>
    </div>
    <h4 class="monthly-batch-container__title">T700i DigiLam-FBDC Cost (no liner)
      <div class="arrow-container">
        -41%
      </div>
    </h4>
    <div class="table-container-manufacturing">
      <table>
        <tr class="total-row lower">
          <td class="title-row">
            Digital<br>
            Batch Run<br>
            Structure A<br>
            SKU 001-005 <br>
          </td>
          <td class="white-text">
            100,000
          </td>
          <td class="white-text">16,667sh
            ~3 Rolls
          </td>
          <td class="gray-text">$26.75
            €0.269
          </td>
          <td class="gray-text">354.2
            32,909
          </td>
          <td><span>$9,476
            </span><br>€8,864
          </td>
        </tr>
      </table>
    </div>
    <p class="footnote">Calculations were performed in $ per MSF, then converted to € per SQM. The conversion was based
      on an exchange
      rate of €1 = $1.069. Liner costs not included in results.</p>
  </div>
</template>

<style lang="scss" scoped>
@import "@/scss/views/why-digital/manufacturing-time.scss";
@import '@/scss/_mixins.scss';

.monthly-batch-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  height: 80vh;

  &__title {
    font-size: 35px;
    position: relative;

    .arrow-container {
      position: absolute;
      width: 106px;
      height: 60px;
      top: 50%;
      right: 30px;
      transform: translateY(-50%);
      background-image: url('/images/why-digital/manufacturing-benefits/green-arrow-down.svg');
      padding: 10px;
      font-size: 28px;
    }
  }
}

.total-row {
  &.lower {
    border-radius: 8px;

    .title-row {
      font-size: 20px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: -0.667px;
      text-align: start;
    }
  }
}

.table-container-manufacturing {
  width: 90%;
  margin: 0 auto;

  th,
  td {
    padding: 10px;
    width: 120px;
  }

  .gray-text {
    color: $color_grey_8C !important;
  }

  .white-text {
    color: $color_white !important;
    font-weight: 400 !important;
  }
}
</style>
